import z from 'zod';
export const price = (args = {}) => z.coerce
    .number()
    .nonnegative()
    .refine((val) => args.maxDecimalPlaces == undefined ||
    new RegExp(`^\\d+(\\.\\d{1,${args.maxDecimalPlaces}})?$`).test(val.toString()), {
    message: `Enter a valid price with up to ${args.maxDecimalPlaces} decimal places.`,
});
export const nonnegativePrice = z.preprocess((val) => (val === '' ? undefined : val), price({ maxDecimalPlaces: 2 }));
export const positiveInt = z.coerce.number().int().positive();
export const positiveNumber = z.coerce.number().positive();
export const optionalPositiveInt = z
    .union([positiveInt, z.literal('').transform(() => undefined)])
    .optional();
export const optionalPositiveNumber = z
    .union([positiveNumber, z.literal('').transform(() => undefined)])
    .optional();
export const PRICE_MAX_DECIMAL_PLACES = 12;
export const STORAGE_TB_PRICE_MAX_DECIMAL_PLACES = PRICE_MAX_DECIMAL_PLACES - 3; // storage is in TB while we convert it to GB when applied
export const storageTbUnitPrice = price({
    maxDecimalPlaces: STORAGE_TB_PRICE_MAX_DECIMAL_PLACES,
});
export const generalUnitPrice = price({
    maxDecimalPlaces: PRICE_MAX_DECIMAL_PLACES,
});
